import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axiosInstance from "../../axios";
import axios from "axios";
import { courseService } from "../../_services";

const UpdatePassword = () => {
  const { t } = useTranslation();

  const initalstate = {
    password: "",
    confirmPassword: "",
  };
  const [userInfo, setUserInfo] = useState(initalstate);
  const [validation, setValidation] = useState(false);
  const [errorMessage, setErrorMesssage] = useState("");
  const [confirmation, setConfirmation] = useState(false);
  const [authentication, setAuthentication] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const handleChange = (e) => {
    setUserInfo({ ...userInfo, [e.target.name]: e.target.value });
  };

  function passwordValidation(password) {
    const re =
      /^.*(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$-%^&+=\-])([\w.\-]).*$/;
    return re.test(password);
  }

  const handleUpdatePassword = (e) => {
    e.preventDefault();
    setValidation(true);
    if (
      userInfo.password !== userInfo.confirmPassword &&
      userInfo.confirmPassword !== "" &&
      userInfo.password !== ""
    ) {
      setErrorMesssage("Password and confirm password does not match");
    } else if (
      passwordValidation(userInfo.confirmPassword) === false &&
      userInfo.password !== ""
    ) {
      setErrorMesssage("Password strength does not meet requirement");
    } else if (passwordValidation(userInfo.confirmPassword) === true) {
      courseService.profileResetPassword(userInfo).then((response) => {
        if (response?.data?.error === false) {
          setConfirmation(true);
          setErrorMesssage("");
        } else {
          setErrorMesssage(response?.data?.message || "Password reset failed.");
        }
      }).catch((error) => {
        setErrorMesssage(error?.response?.data?.message || "An error occurred. Please try again.");
      });
    }
  };

  useEffect(() => {
    const token = window.location.href;
    const strLength = token.length;
    const firstIndex = token.indexOf("=");
    const newToken = token.substring(firstIndex + 1, strLength);
    setAuthentication(newToken);
  }, []);

  return (
    <div>
      <div className="LoginPage">
        <div className="signupScreen">
          <div className="inner-wrapper ">
            <div className="left-section">
              <div className="section-header">Update password</div>
              <h5>
                Connecting learners, educators and parents from around the world
                on a common inclusive &amp; truely multilingual platform.
              </h5>
            </div>

            <div className="right-section">
              <div className="right-top">
                <h5>{t("Update Password ")}</h5>
                {/* <div className="finePrnt">
                  {t("notRegistered")} <Link to="/register">{t("Signup")}</Link>
                </div> */}
              </div>
              {confirmation ? (
                <div className="form-wrapper">
                  <div className="align-item">
                    <img
                      src={`${process.env.REACT_APP_SMIK_API_BASEURL}/icons/icon-complete-check.svg`}
                      alt="check-complete"
                    />
                    <p>Your Password has been successfully updated !</p>
                  </div>
                </div>
              ) : (
                <div className="form-wrapper">
                  <form className="center" onSubmit={handleUpdatePassword}>
                    <div className="form-row">
                      <i className="icon icon-lock-closed"></i>
                      <input
                        placeholder={t("Enter new password")}
                        aria-label="password"
                        type={showPassword ? "text" : "password"}
                        name="password"
                        className={`${userInfo.password === "" &&
                          validation === true &&
                          "validate-error"
                          }`}
                        value={userInfo.password}
                        onChange={handleChange}
                      />
                      <i
                        onClick={() => setShowPassword(!showPassword)}
                        className={`icon ${showPassword ? "icon-view-password-active" : "icon-view-password"}`}
                      ></i>
                    </div>
                    <div className="form-row">
                      <i className="icon icon-lock-closed"></i>
                      <input
                        placeholder={t("Re-Enter new password")}
                        aria-label="confirmPassword"
                        type={showConfirmPassword ? "text" : "password"}
                        name="confirmPassword"
                        className={`${userInfo.confirmPassword === "" &&
                          validation === true &&
                          "validate-error"
                          }`}
                        value={userInfo.confirmPassword}
                        onChange={handleChange}
                      />
                      <i
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                        className={`icon ${showConfirmPassword ? "icon-view-password-active" : "icon-view-password"}`}
                      ></i>
                    </div>
                    <p className="text-color">{errorMessage}</p>
                    <div className="form-row flex-wrapper">
                      <button className="btn btn-login">Update Password</button>
                    </div>
                  </form>
                    <div className="text-center mt-3">
                      {t("notRegistered")} <Link to="/register">{t("Signup")}</Link>
                    </div>
                </div>
              )}

              {/* <div className="social-media-login">
                <div className="title-wrap">
                  <div>{t("or")}</div>
                  <div>{t("Connect with social media")}</div>
                </div>
                <div>
                  <ul>
                    <li>
                      <a
                        title="Google link"
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.smiklearn.com/">
                        <i className="icon-google"></i>
                      </a>
                    </li>
                    <li>
                      <a
                        aria-label="Link to Facebook"
                        href="https://www.facebook.com/smiklearncom/"
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        <i className="icon-facebook"></i>
                      </a>
                    </li>
                    <li>
                      <a
                        aria-label="Link to Linked In"
                        href="https://www.linkedin.com/company/smiklearn/"
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        <i className="icon-linkedIn"></i>
                      </a>
                    </li>
                    <li>
                      <a
                        aria-label="Link to Twitter"
                        href="https://twitter.com/smiklearnglobal"
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        <i className="icon-twitter"></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdatePassword;
